import { Type } from "class-transformer";
import { IEntity } from "@interfaces/entity";
import { Address } from "../address";
import { UserRole } from "../identity/userRole";
import { Customer } from "@models/customer";
import { RfidCard } from "@models/rfidCard";
import { Setting } from "@models/setting";
import { ChargingStation } from "@models/charging-station";
import { Pricing } from "@models/pricing";

export class User implements IEntity {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  type: string;
  company: string;
  phone: string;
  pictureUri: string;
  pictureFileName: string;
  isMasterUser: boolean;
  organisationMail: string;

  @Type(() => Address)
  address: Address;
  addressId: number;

  @Type(() => Customer)
  selectedCustomer: Customer;
  selectedCustomerId: number;

  rfidCards: RfidCard[];
  allowedChargingStations: ChargingStation[];

  @Type(() => UserRole)
  userRoles: UserRole[];

  @Type(() => Customer)
  settings: Setting;
  settingId: number;
  
  @Type(() => Pricing)
  pricing: Pricing;
  pricingId: number;

  entityName = "User";

  constructor(formValue?: Partial<User>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<User>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }

  get rfidCardsString(): string {
    var rfidCards = this.rfidCards.map(function (item) {
      return item['idTag'];
    });
    return rfidCards.toString();
  }

  get allowedChargingStationsString(): string {
    var allowedChargingStations = this.allowedChargingStations.map(function (item) {
      return item['name'];
    });
    return allowedChargingStations.toString();
  }

  get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  getRolesAsString(): string {
    var roleString = "";

    for (var i = 0; i < this.userRoles.length; i++) {
      roleString = roleString.concat(this.userRoles[i].role.name);

      if (!(i == this.userRoles.length - 1)) {
        roleString = roleString.concat(", ");
      }
    }

    return roleString;
  }

  getRolesAsStringArray(): string[] {
    var rolesStringArray: string[] = [];

    for (var userRole of this.userRoles) {
      rolesStringArray.push(userRole.role.name);
    }

    return rolesStringArray;
  }

  //getRolesAsString(): string {
  //  var roleString = "";

  //  for (var i = 0; i < this.roles.length; i++) {
  //    roleString = roleString.concat(this.roles[i].name);

  //    if (!(i == this.roles.length - 1)) {
  //      roleString = roleString.concat(", ");
  //    }
  //  }

  //  return roleString;
  //}

  //getRolesAsStringArray(): string[] {
  //  var rolesStringArray: string[] = [];

  //  for (var role of this.roles) {
  //    rolesStringArray.push(role.name);
  //  }

  //  return rolesStringArray;
  //}
}
